import { Action, createReducer, on } from '@ngrx/store';
import { remove } from 'lodash';

import { Store } from '../../pages/stores/store';
import { PremiitError } from '../../utils/premiit-error';
import * as storeActions from '../actions/stores.actions';

export interface StoreState {
  data: Store[];
  selected: Store;
  loading: boolean;
  error: PremiitError;
}

const storeInitState: StoreState = {
  data: [],
  selected: null,
  loading: false,
  error: null,
};

const _storeReducer = createReducer(storeInitState,
  on(storeActions.getStoresAction, (state: StoreState) => ({ ...state, loading: false })),
  on(storeActions.getStoresSuccessAction, (state: StoreState, { stores }) => ({
    ...state,
    data: stores,
    loading: false,
    error: null,
  })),
  on(storeActions.getStoresError, (state: StoreState, { error }) => ({ ...state, loading: false, error })),
  on(storeActions.createStoreAction, (state: StoreState) => ({ ...state, loading: true })),
  on(storeActions.createStoreSuccessAction, (state: StoreState) => ({
    ...state,
    loading: false,
    error: null
  })),
  on(storeActions.createStoreError, (state: StoreState, { error }) => ({ ...state, loading: false, error })),
  on(storeActions.selectStore, (state: StoreState, { store }) => ({ ...state, selected: store })),
  on(storeActions.updateStoreAction, (state: StoreState) => ({ ...state, loading: true })),
  on(storeActions.updateStoreSuccess, (state: StoreState, { store }) => {
    const stores = [...state.data];
    stores.map((item: Store) => {
      if (item.id === store.id) {
        item = store;
      }
      return item;
    });
    return {
      ...state,
      data: stores,
      loading: false,
      selected: null,
    };
  }),
  on(storeActions.updateStoreError, (state: StoreState, { error }) => ({ ...state, loading: false, error })),
  on(storeActions.deleteStoreAction, (state: StoreState) => ({ ...state, loading: true })),
  on(storeActions.deleteStoreSuccess, (state: StoreState, { store }) => {
    const stores = [...state.data];
    remove(stores, (item: Store) => store.id === item.id);
    return { ...state, loading: false, selected: null, data: stores };
  })
);

export function StoresReducer(state: StoreState, action: Action): any {
  return _storeReducer(state, action);
}
